import register from 'preact-custom-element'
import BlogAll from 'snippets/template-blog-all/template-blog-all'

let devtools
if (process.env.NODE_ENV === 'development') {
  devtools = require('preact/devtools')
}

register(BlogAll, 'blog-all')
